import { render, staticRenderFns } from "./reducePenalty.vue?vue&type=template&id=65538c05&scoped=true&"
import script from "./reducePenalty.vue?vue&type=script&lang=ts&"
export * from "./reducePenalty.vue?vue&type=script&lang=ts&"
import style0 from "./reducePenalty.vue?vue&type=style&index=0&id=65538c05&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65538c05",
  null
  
)

export default component.exports